import AdapterDateFns from "@date-io/date-fns";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import InputLabel from "@material-ui/core/InputLabel";
import MUISelect from "@material-ui/core/Select";
import FormControl, { FormControlProps } from "@material-ui/core/FormControl";
import React, { FC, useState } from "react";
import { DatePicker, LocalizationProvider } from "@material-ui/pickers";
import { MenuItem, TextField } from "@material-ui/core";
import { makeStyles, styled } from "@material-ui/styles";

import { ReportTimeFrames } from "../../../../../types/campaignTypes";

type TimeFrameSelectorProps = {
  selectedTimeFrame: string;
  handleTimeFrameChange: (event: any) => void;
  disablePortal?: boolean;
};

const StyledFormControl = styled(FormControl)<FormControlProps>(() => ({
  "& .MuiInputBase-root": {
    height: 48,
  },
  "& label": {
    transform: "translate(14px, 17px) scale(1)",
  },
  "& label.Mui-focused": {
    color: "#034980",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "1px solid #9E9E9E",
      borderRadius: 4,
    },
    "& .Mui-focused fieldset": {
      border: "1px solid #034980",
    },
  },
}));

const useStyles = makeStyles({
  selector: {
    width: "250px",
    marginLeft: "8px",
    "& input": {
      padding: "6px",
    },
    "& button": {
      minWidth: "30px",
      fontWeight: "normal",
      marginLeft: 0,
    },
    "& fieldset": {
      border: "1px solid rgb(158, 158, 158)",
    },
  },
  customDateSelector: {
    display: "flex",
    alignItems: "center",

    "& button": {
      minWidth: "unset !important",
    },
  },
});

const TimeFrameSelector: FC<TimeFrameSelectorProps> = ({
  selectedTimeFrame,
  handleTimeFrameChange,
  disablePortal = false,
}) => {
  const [customDate, setCustomDate] = useState<Date | null>(null);
  const [timeFrame, setTimeFrame] = useState<string>(selectedTimeFrame);
  const [isDateSelectorDisplayed, setIsDateSelectorDisplayed] = useState<boolean>(false);
  const classes = useStyles();

  const handleCustomDateChange = (date: Date | null) => {
    if (date) {
      setCustomDate(date);
      setTimeFrame(ReportTimeFrames.CUSTOM_DATE);
      handleTimeFrameChange({
        target: {
          value: ReportTimeFrames.CUSTOM_DATE,
          custom_date: date.toISOString(),
        },
      });
    }
  };

  const handleChange = (event: any) => {
    const { value } = event.target;

    if (value === ReportTimeFrames.CUSTOM_DATE) {
      setIsDateSelectorDisplayed(true);

      if (customDate) {
        handleCustomDateChange(customDate);
      }
    } else {
      handleTimeFrameChange(event);
    }

    setTimeFrame(value);
  };

  return !isDateSelectorDisplayed ? (
    <StyledFormControl variant="outlined" className={classes.selector} fullWidth>
      <InputLabel>Time Frame</InputLabel>
      <MUISelect
        value={timeFrame}
        onChange={handleChange}
        displayEmpty
        label="Time Frame"
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          getContentAnchorEl: null,
        }}
      >
        {!timeFrame ? <MenuItem>Time Frame</MenuItem> : null}
        <MenuItem value={ReportTimeFrames.DAYS_7}>7 Days</MenuItem>
        <MenuItem value={ReportTimeFrames.DAYS_30}>30 Days</MenuItem>
        <MenuItem value={ReportTimeFrames.DAYS_90}>90 Days</MenuItem>
        <MenuItem value={ReportTimeFrames.ALL_TIME}>All time</MenuItem>
        {/* {!customDate && <MenuItem value={ReportTimeFrames.CUSTOM_DATE}>Custom Date</MenuItem>}
        {customDate && <MenuItem value={ReportTimeFrames.CUSTOM_DATE}>{customDate.toLocaleDateString()}</MenuItem>} */}
      </MUISelect>
    </StyledFormControl>
  ) : (
    <div className={`${classes.customDateSelector}`}>
      <ArrowLeftIcon onClick={() => setIsDateSelectorDisplayed(false)} />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label="Select Date"
          value={customDate}
          onChange={(date) => handleCustomDateChange(date)}
          renderInput={(params) => <TextField {...params} fullWidth />}
          PopperProps={{
            disablePortal,
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

export default TimeFrameSelector;
